import React, { Component } from "react";

import './AttributesTable.css'

export class AttributesTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
        }
    }
    render() {
        return (
            <div className='attributes'>
                {
                    this.props.list.map((item) => {
                        return (
                            <div key={item.key} className='attributes__row' style={{display: item.show ? '' : 'none'}}>
                                <div>{item.key}</div>
                                <div dangerouslySetInnerHTML={{__html:item.value}}></div>
                            </div>
                        );
                    })  
                }
            </div>              
        );
    }
}
    